
import i18n from '../../../lib/utility/i18n';

export const getFileNameFromUrl = (url) => {
  const parts = url.split('/');
  const fileName = parts[parts.length - 1];
  return fileName.split('_').slice(-1);
}


export const getArchiveConfirmLayout = (archived, list) => {
  const title = archived ?
    i18n.t('Unarchive Playlist?') :
    i18n.t('Archive Playlist?');

  const buttonText = archived ?
    i18n.t('Yes') :
    i18n.t('Archive');

  let secondaryText = i18n.t('Are you sure you want to unarchive this playlist? Doing so will make it available again for edits and use in programs.');
  if(!archived) {
    secondaryText = (<>
      {i18n.t('If you archive this playlist, it can no longer be added to a program. If it’s currently in use in a program, it must be manually removed from the program.')}
      <h4>{i18n.t('Currently in use in:')}</h4>
      {list?.map((program) => {
        return (<li key={program.id}>{program.attributes.name}</li>);
      })}
    </>);
  }
  return { title, buttonText, secondaryText };

}